import { useEffect } from 'react';

const FrameBuster = () => {
  useEffect(() => {
    const isFramed = window.self !== window.top;

    if (isFramed) {
      console.warn('⚠️ Security Alert: This application is being loaded in an iframe.');
      
      try{
        window.top.location = window.self.location;
      } catch (error) {
        console.error('Unable to break out of frame. Server-side headers should prevent this.');
      }
    }
    const intervalId = setInterval(() => {
      if (window.self !== window.top) {
        try {
          window.top.location = window.self.location;
        } catch (e) {
        }
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return null;
};

export default FrameBuster;

